var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-dropdown no-spaces self-close button-selection" },
    [
      _c("input", {
        staticClass: "list-dropdown__trigger",
        attrs: { type: "checkbox", id: "filterSort" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "list-dropdown__wrapper" }, [
        _c(
          "label",
          { staticClass: "list-dropdown__title", attrs: { for: "filterSort" } },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.selected.title))
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "list-dropdown__container" }, [
          _c("div", { staticClass: "list-dropdown__content" }, [
            _c("div", { staticClass: "list-dropdown__scroll" }, [
              _c(
                "ul",
                { staticClass: "list-dropdown__select-list bigger" },
                _vm._l(_vm.sortOrders, function(item) {
                  return _c("li", [
                    _c(
                      "button",
                      {
                        class: { selected: item.title == _vm.selected.title },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.selectOrder(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item.title))]
                    )
                  ])
                }),
                0
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-dropdown__bg" })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }